import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

const NIVEIS_ACESSO = {
  admin:        { label: 'Administrador', cor: '#6B2FA0', bg: '#f3e8ff', descricao: 'Acesso total ao sistema' },
  gestor:       { label: 'Gestor',        cor: '#0891b2', bg: '#e0f2fe', descricao: 'Acesso a gestão e relatórios' },
  closer:       { label: 'Closer',        cor: '#C9A84C', bg: '#FFFBEB', descricao: 'Funil Closer de Advocacia' },
  sdr:          { label: 'SDR',           cor: '#4A90D9', bg: '#EBF4FF', descricao: 'Funil SDR' },
  adm:          { label: 'Adm',           cor: '#9B7FD4', bg: '#F5F0FF', descricao: 'Funil Adm de Advocacia' },
  saude:        { label: 'Saúde',         cor: '#D4789B', bg: '#FFF0F5', descricao: 'Funil de Saúde' },
  infoprodutos: { label: 'Infoprodutos',  cor: '#5BAD8F', bg: '#F0FFF8', descricao: 'Funil de Infoprodutos' },
};

const MODULOS = [
  { key: 'dashboard',     label: 'Dashboard' },
  { key: 'leads',         label: 'Leads' },
  { key: 'crm',           label: 'CRM' },
  { key: 'agenda',        label: 'Agenda' },
  { key: 'projetos',      label: 'Projetos' },
  { key: 'casos',         label: 'Casos' },
  { key: 'conteudo',      label: 'Conteúdo' },
  { key: 'metas',         label: 'Metas' },
  { key: 'financeiro',    label: 'Financeiro' },
  { key: 'relatorios',    label: 'Relatórios' },
  { key: 'colaboradores', label: 'Colaboradores' },
  { key: 'configuracoes', label: 'Configurações' },
  { key: 'playbook',      label: 'Playbook' },
];

const FUNIS_DISPONIVEIS = [
  { key: 'advocacia_sdr',    label: 'Advocacia — SDR' },
  { key: 'advocacia_closer', label: 'Advocacia — Closer' },
  { key: 'advocacia_adm',    label: 'Advocacia — Adm' },
  { key: 'saude',            label: 'Saúde' },
  { key: 'infoprodutos',     label: 'Infoprodutos' },
];

const acessoPadrao = (nivel) => {
  const tudo  = { dashboard: true, leads: true, crm: true, agenda: true, metas: true, projetos: true, casos: true, conteudo: true, financeiro: true, relatorios: true, colaboradores: true, configuracoes: true, playbook: true };
  const basico = { dashboard: true, leads: true, crm: true, agenda: true, metas: true, projetos: false, casos: false, conteudo: false, financeiro: false, relatorios: false, colaboradores: false, configuracoes: false, playbook: true };
  if (nivel === 'admin' || nivel === 'gestor') return tudo;
  if (nivel === 'adm')          return { ...basico, casos: true, financeiro: true, agenda: true, conteudo: true };
  if (nivel === 'closer')       return { ...basico, casos: true };
  if (nivel === 'saude')        return { ...basico };
  if (nivel === 'infoprodutos') return { ...basico, conteudo: true, projetos: true };
  return basico; // sdr e qualquer outro
};

const FORM_VAZIO = { nome: '', cargo: '', setor: '', email: '', telefone: '', nivel: 'sdr', status: 'Ativo', cor: '#4A90D9', foto_url: '', funis: [], acesso: acessoPadrao('sdr') };

export default function Colaboradores() {
  const [colaboradores, setColaboradores] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [modalAberto, setModalAberto] = useState(false);
  const [colaboradorEditando, setColaboradorEditando] = useState(null);
  const [abaModal, setAbaModal] = useState('dados');
  const [form, setForm] = useState(FORM_VAZIO);
  const [busca, setBusca] = useState('');
  const [erro, setErro] = useState('');
  const [confirmInativar, setConfirmInativar] = useState(null);

  useEffect(() => { carregarColaboradores(); }, []);

  async function carregarColaboradores() {
    setCarregando(true);
    const { data, error } = await supabase.from('colaboradores').select('*').order('nome');
    if (!error && data) setColaboradores(data);
    setCarregando(false);
  }

  const filtrados = colaboradores.filter(c =>
    (c.nome||'').toLowerCase().includes(busca.toLowerCase()) ||
    (c.cargo||'').toLowerCase().includes(busca.toLowerCase())
  );

  function abrirNovo() {
    setColaboradorEditando(null);
    setForm(FORM_VAZIO);
    setAbaModal('dados');
    setErro('');
    setModalAberto(true);
  }

  function abrirEditar(colab) {
    setColaboradorEditando(colab);
    setForm({
      nome: colab.nome || '',
      cargo: colab.cargo || '',
      setor: colab.setor || '',
      email: colab.email || '',
      telefone: colab.telefone || '',
      nivel: colab.nivel || 'sdr',
      status: colab.status || 'Ativo',
      cor: colab.cor || '#4A90D9',
      foto_url: colab.foto_url || '',
      funis: colab.funis || [],
      acesso: colab.acesso || acessoPadrao(colab.nivel || 'sdr'),
    });
    setAbaModal('dados');
    setErro('');
    setModalAberto(true);
  }

  async function salvar() {
    if (!form.nome.trim()) { setErro('Nome é obrigatório.'); return; }
    setSalvando(true);
    setErro('');
    const payload = {
      nome: form.nome.trim(),
      cargo: form.cargo.trim(),
      setor: form.setor.trim(),
      email: form.email.trim(),
      telefone: form.telefone.trim(),
      nivel: form.nivel,
      status: form.status,
      cor: form.cor,
      foto_url: form.foto_url || null,
      funis: form.funis,
      acesso: form.acesso,
    };
    if (colaboradorEditando) {
      const { data, error } = await supabase.from('colaboradores').update(payload).eq('id', colaboradorEditando.id).select().single();
      if (error) { setErro('Erro ao salvar: ' + error.message); setSalvando(false); return; }
      setColaboradores(colaboradores.map(c => c.id === colaboradorEditando.id ? data : c));
    } else {
      const { data, error } = await supabase.from('colaboradores').insert([payload]).select().single();
      if (error) { setErro('Erro ao criar: ' + error.message); setSalvando(false); return; }
      setColaboradores([...colaboradores, data]);
    }
    setSalvando(false);
    setModalAberto(false);
  }

  async function alternarStatus(colab) {
    const novoStatus = colab.status === 'Ativo' ? 'Inativo' : 'Ativo';
    const { data } = await supabase.from('colaboradores').update({ status: novoStatus }).eq('id', colab.id).select().single();
    if (data) setColaboradores(colaboradores.map(c => c.id === colab.id ? data : c));
    setConfirmInativar(null);
  }

  function toggleFunil(key) {
    const funis = form.funis || [];
    setForm({ ...form, funis: funis.includes(key) ? funis.filter(f => f !== key) : [...funis, key] });
  }

  function toggleAcesso(key) {
    setForm({ ...form, acesso: { ...form.acesso, [key]: !form.acesso?.[key] } });
  }

  function mudarNivel(nivel) {
    setForm({ ...form, nivel, acesso: acessoPadrao(nivel) });
  }

  const nc = (nivel) => NIVEIS_ACESSO[nivel] || NIVEIS_ACESSO.sdr;
  const iniciais = (nome) => (nome||'').split(' ').map(p=>p[0]).slice(0,2).join('');

  if (carregando) return <div style={{ padding:40, textAlign:'center', color:'var(--gray-400)' }}>Carregando colaboradores...</div>;

  return (
    <div>
      <div className="section-header">
        <h2 className="section-title">Colaboradores</h2>
        <div className="section-line" />
      </div>

      <div className="filter-bar" style={{ marginBottom:20 }}>
        <input placeholder="🔍  Buscar por nome ou cargo..." value={busca} onChange={e => setBusca(e.target.value)}
          style={{ flex:1, padding:'8px 14px', border:'1.5px solid rgba(107,33,168,0.12)', borderRadius:10, fontSize:12.5, background:'#FAF8FF', color:'#1E0A3C', outline:'none', fontFamily:'Poppins,sans-serif' }} />
        <div style={{ flex:1 }} />
        <button onClick={abrirNovo}
          style={{ background:'linear-gradient(135deg,#b45309,#D4AF37)', color:'white', border:'none', padding:'9px 22px', borderRadius:10, fontWeight:700, cursor:'pointer', fontSize:13, fontFamily:'Poppins,sans-serif', boxShadow:'0 4px 14px rgba(180,83,9,0.3)' }}>
          + Colaborador
        </button>
      </div>

      {colaboradores.length === 0 && !carregando && (
        <div className="card" style={{ padding:40, textAlign:'center', color:'var(--gray-400)' }}>
          Nenhum colaborador cadastrado ainda.
        </div>
      )}

      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:16 }}>
        {filtrados.map(c => {
          const nivel = nc(c.nivel);
          return (
            <div key={c.id} className="card" style={{ padding:24, opacity: c.status === 'Inativo' ? 0.65 : 1 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:16 }}>
                <div style={{ display:'flex', gap:12, alignItems:'center' }}>
                  <div style={{ width:48, height:48, borderRadius:'50%', background: c.cor || 'var(--purple)', display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontWeight:700, fontSize:18, flexShrink:0, overflow:'hidden' }}>
                    {c.foto_url ? <img src={c.foto_url} alt={c.nome} style={{ width:'100%', height:'100%', objectFit:'cover' }} /> : iniciais(c.nome)}
                  </div>
                  <div>
                    <div style={{ fontWeight:700, fontSize:14, color:'var(--text-primary)' }}>{c.nome}</div>
                    <div style={{ fontSize:12, color:'var(--gray-400)' }}>{c.cargo}</div>
                  </div>
                </div>
                <button onClick={() => abrirEditar(c)}
                  style={{ background:'transparent', border:'1px solid var(--border)', padding:'4px 10px', borderRadius:5, cursor:'pointer', fontSize:11, color:'var(--text-secondary)' }}>
                  Editar
                </button>
              </div>

              <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:12 }}>
                <span style={{ background:nivel.bg, color:nivel.cor, padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:700 }}>{nivel.label}</span>
                <span style={{ background: c.status==='Ativo' ? '#dcfce7' : '#fee2e2', color: c.status==='Ativo' ? '#16a34a' : '#dc2626', padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600 }}>{c.status || 'Ativo'}</span>
              </div>

              {c.email && <div style={{ fontSize:12, color:'var(--text-secondary)', marginBottom:4 }}>📧 {c.email}</div>}
              {c.telefone && <div style={{ fontSize:12, color:'var(--text-secondary)', marginBottom:12 }}>📱 {c.telefone}</div>}

              <div style={{ borderTop:'1px solid var(--border)', paddingTop:10, display:'flex', justifyContent:'space-between', alignItems:'flex-end' }}>
                <div>
                  <div style={{ fontSize:11, color:'var(--gray-400)', marginBottom:6, fontWeight:600, textTransform:'uppercase' }}>Funis</div>
                  <div style={{ display:'flex', gap:4, flexWrap:'wrap' }}>
                    {(c.funis || []).map(f => {
                      const funil = FUNIS_DISPONIVEIS.find(fd => fd.key === f);
                      return funil ? (
                        <span key={f} style={{ background:'var(--bg-secondary)', border:'1px solid var(--border)', padding:'2px 7px', borderRadius:20, fontSize:10, color:'var(--text-secondary)' }}>
                          {funil.label}
                        </span>
                      ) : null;
                    })}
                    {(!c.funis || c.funis.length === 0) && <span style={{ fontSize:11, color:'var(--gray-400)' }}>Nenhum</span>}
                  </div>
                </div>
                {c.status !== 'Inativo' && (
                  <button onClick={() => setConfirmInativar(c)}
                    style={{ background:'transparent', border:'1px solid #fee2e2', color:'#dc2626', padding:'3px 8px', borderRadius:5, cursor:'pointer', fontSize:10 }}>
                    Inativar
                  </button>
                )}
                {c.status === 'Inativo' && (
                  <button onClick={() => alternarStatus(c)}
                    style={{ background:'transparent', border:'1px solid #dcfce7', color:'#16a34a', padding:'3px 8px', borderRadius:5, cursor:'pointer', fontSize:10 }}>
                    Reativar
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Confirmação inativar */}
      {confirmInativar && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1100 }}>
          <div className="card" style={{ width:360, padding:28, textAlign:'center' }}>
            <div style={{ fontSize:32, marginBottom:12 }}>⚠️</div>
            <div style={{ fontWeight:700, fontSize:15, marginBottom:8 }}>Inativar {confirmInativar.nome}?</div>
            <div style={{ fontSize:13, color:'var(--gray-400)', marginBottom:20 }}>O colaborador perderá acesso ao sistema enquanto estiver inativo.</div>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={() => alternarStatus(confirmInativar)} style={{ flex:1, background:'#dc2626', color:'white', border:'none', padding:'10px', borderRadius:7, fontWeight:700, cursor:'pointer' }}>Sim, inativar</button>
              <button onClick={() => setConfirmInativar(null)} style={{ flex:1, background:'transparent', border:'1px solid var(--border)', padding:'10px', borderRadius:7, cursor:'pointer', color:'var(--text-secondary)' }}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal criação/edição */}
      {modalAberto && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
          <div className="card" style={{ width:560, maxHeight:'90vh', overflowY:'auto', padding:32 }}>

            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
              <h3 style={{ margin:0, color:'var(--purple)', fontSize:18 }}>
                {colaboradorEditando ? 'Editar Colaborador' : 'Novo Colaborador'}
              </h3>
              <button onClick={() => setModalAberto(false)}
                style={{ background:'transparent', border:'none', fontSize:20, cursor:'pointer', color:'var(--gray-400)' }}>×</button>
            </div>

            {erro && (
              <div style={{ background:'#fee2e2', border:'1px solid #dc2626', borderRadius:6, padding:'10px 14px', marginBottom:16, fontSize:13, color:'#dc2626' }}>
                {erro}
              </div>
            )}

            <div style={{ display:'flex', gap:8, marginBottom:24 }}>
              {[{ key:'dados', label:'Dados' }, { key:'acesso', label:'Nível' }, { key:'funis', label:'Funis' }, { key:'modulos', label:'Módulos' }].map(a => (
                <button key={a.key} onClick={() => setAbaModal(a.key)}
                  style={{ padding:'7px 16px', borderRadius:20, border:'1px solid var(--border)', cursor:'pointer', fontSize:12, fontWeight: abaModal===a.key ? 700 : 400,
                    background: abaModal===a.key ? 'var(--purple)' : 'transparent',
                    color: abaModal===a.key ? 'white' : 'var(--text-secondary)' }}>
                  {a.label}
                </button>
              ))}
            </div>

            {abaModal === 'dados' && (
              <div>
                <div style={{ marginBottom:16 }}>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:8, textTransform:'uppercase' }}>Cor do avatar</label>
                  <div style={{ display:'flex', gap:8 }}>
                    {['#6B2FA0','#4A90D9','#D4789B','#C9A84C','#5BAD8F','#E05454','#9B7FD4'].map(cor => (
                      <div key={cor} onClick={() => setForm({...form, cor})}
                        style={{ width:28, height:28, borderRadius:'50%', background:cor, cursor:'pointer', border: form.cor===cor ? '3px solid #333' : '2px solid transparent' }} />
                    ))}
                  </div>
                </div>
                {[
                  { label:'Nome completo *', key:'nome', type:'text' },
                  { label:'Cargo / Função', key:'cargo', type:'text' },
                  { label:'Setor', key:'setor', type:'text' },
                  { label:'E-mail', key:'email', type:'email' },
                  { label:'Telefone', key:'telefone', type:'text' },
                  { label:'URL da foto (link público)', key:'foto_url', type:'text' },
                ].map(f => (
                  <div key={f.key} style={{ marginBottom:14 }}>
                    <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>{f.label}</label>
                    <input type={f.type} value={form[f.key] || ''} onChange={e => setForm({...form, [f.key]: e.target.value})}
                      style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)', boxSizing:'border-box' }} />
                  </div>
                ))}
                <div style={{ marginBottom:14 }}>
                  <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Status</label>
                  <select value={form.status || 'Ativo'} onChange={e => setForm({...form, status: e.target.value})}
                    style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', color:'var(--text-primary)' }}>
                    <option>Ativo</option>
                    <option>Inativo</option>
                    <option>Férias</option>
                  </select>
                </div>
              </div>
            )}

            {abaModal === 'acesso' && (
              <div>
                <div style={{ fontSize:13, color:'var(--gray-400)', marginBottom:16 }}>
                  O nível define as permissões padrão. Ajuste módulo por módulo na aba "Módulos".
                </div>
                <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                  {Object.entries(NIVEIS_ACESSO).map(([key, val]) => (
                    <div key={key} onClick={() => mudarNivel(key)}
                      style={{ padding:'14px 16px', borderRadius:8, border:`2px solid ${form.nivel===key ? val.cor : 'var(--border)'}`, background: form.nivel===key ? val.bg : 'transparent', cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                      <div>
                        <div style={{ fontWeight:700, fontSize:13, color: form.nivel===key ? val.cor : 'var(--text-primary)' }}>{val.label}</div>
                        <div style={{ fontSize:11, color:'var(--gray-400)', marginTop:2 }}>{val.descricao}</div>
                      </div>
                      {form.nivel===key && <span style={{ color:val.cor, fontSize:18 }}>✓</span>}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {abaModal === 'funis' && (
              <div>
                <div style={{ fontSize:13, color:'var(--gray-400)', marginBottom:16 }}>
                  Selecione quais funis do CRM este colaborador pode acessar.
                </div>
                <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                  {FUNIS_DISPONIVEIS.map(f => {
                    const ativo = (form.funis || []).includes(f.key);
                    return (
                      <div key={f.key} onClick={() => toggleFunil(f.key)}
                        style={{ padding:'12px 16px', borderRadius:8, border:`2px solid ${ativo ? 'var(--purple)' : 'var(--border)'}`, background: ativo ? '#f3e8ff' : 'transparent', cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                        <span style={{ fontSize:13, fontWeight: ativo ? 700 : 400, color: ativo ? 'var(--purple)' : 'var(--text-primary)' }}>{f.label}</span>
                        {ativo && <span style={{ color:'var(--purple)' }}>✓</span>}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {abaModal === 'modulos' && (
              <div>
                <div style={{ fontSize:13, color:'var(--gray-400)', marginBottom:16 }}>
                  Defina quais módulos este colaborador pode acessar.
                </div>
                <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                  {MODULOS.map(m => {
                    const ativo = form.acesso?.[m.key] || false;
                    return (
                      <div key={m.key} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 16px', background:'var(--bg-secondary)', borderRadius:8 }}>
                        <span style={{ fontSize:13, color:'var(--text-primary)' }}>{m.label}</span>
                        <div onClick={() => toggleAcesso(m.key)}
                          style={{ width:44, height:24, borderRadius:20, background: ativo ? 'var(--purple)' : 'var(--border)', cursor:'pointer', position:'relative', transition:'background 0.2s' }}>
                          <div style={{ width:18, height:18, borderRadius:'50%', background:'white', position:'absolute', top:3, left: ativo ? 23 : 3, transition:'left 0.2s' }} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            <div style={{ display:'flex', gap:10, marginTop:24 }}>
              <button onClick={salvar} disabled={salvando}
                style={{ flex:1, background:'var(--purple)', color:'white', border:'none', padding:'12px', borderRadius:7, fontWeight:700, cursor:'pointer', fontSize:14, opacity: salvando ? 0.7 : 1 }}>
                {salvando ? 'Salvando...' : 'Salvar'}
              </button>
              <button onClick={() => setModalAberto(false)}
                style={{ flex:1, background:'transparent', border:'1px solid var(--border)', padding:'12px', borderRadius:7, cursor:'pointer', color:'var(--text-secondary)', fontSize:14 }}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
